import { useMutation } from 'react-query';
import {
  convertBettieEnergies,
  type ConvertBettieEnergiesResponse
} from '../../services/bettieEnergiesService';

export function useConvertBettieEnergies() {
  return useMutation<ConvertBettieEnergiesResponse, Error>(() => convertBettieEnergies());
}
